<div class="choose-file">
    <div class="wrapper" (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
        <div class="closer"></div>
    </div>
    <div class="title">Upload ID Type</div>
    <div class="upload-document">
        <label class="">
            <input type="file" [accept]="acceptFormat" (change)="onFileSelected($event)" style="display: none" />
            <span class="label">Upload Document</span>
        </label>
    </div>
    <div class="seperator">OR</div>
    <div class="use-camera">
        <label class="camera" (click)="startCamera()">
            <span class="label">Use Camera</span>
        </label>
    </div>
</div>